import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0ad14558&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0ad14558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad14558",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsLogoDesktop: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/LogoDesktop.vue').default,IconsCamera: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Camera.vue').default,IconsHeadphone: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Headphone.vue').default,IconsChoir: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Choir.vue').default,IconsNewspaper: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Newspaper.vue').default,IconsFacebookOrange: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/FacebookOrange.vue').default,IconsLinkedin: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Linkedin.vue').default,IconsInstagram: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Instagram.vue').default,DownloadLinks: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/base/DownloadLinks.vue').default})
